export default "__VITE_ASSET__3VbKY3WD__"